import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { adminService } from '@/services/admin.service';
import { QUERY_KEYS } from '@/utils/constants';

export const useAllSessions = () =>
  useQuery({
    queryKey: QUERY_KEYS.ADMIN.SESSIONS,
    queryFn: adminService.getAllSessions,
    placeholderData: keepPreviousData,
  });

export const useRevokeAnySession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => adminService.revokeSession(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEYS.ADMIN.SESSIONS }),
  });
};
